import {
  FETCH_PERMISSIONS,
  CHANGE_OP_PWD,
  CHANGE_CU_PWD
} from "../actions/types";

const INITIAL_STATE = {
  operator: {
    username: "operator1",
    password: "123",
    isOperator: true
  },
  customer: {
    username: "customer1",
    password: "123",
    isOperator: false
  }
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PERMISSIONS:
      return payload;

    case CHANGE_OP_PWD:
      return { ...state, ...payload };

    case CHANGE_CU_PWD:
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/permissions_reducer.js